import { faDiscord } from '@fortawesome/free-brands-svg-icons'
import { faGraduationCap } from '@fortawesome/pro-light-svg-icons/faGraduationCap'
import { faSquareTerminal } from '@fortawesome/pro-light-svg-icons/faSquareTerminal'
import { faWallet } from '@fortawesome/pro-light-svg-icons/faWallet'

import { METAMASK_DOCS_DEVELOPER_URL, TRACKED_GETTING_STARTED_DISCORD_LINK } from '@infura/packages.common/constants'

const INFURA_LOGO = '/images/logos/infura-circle.svg'
const TRUFFLE_LOGO = '/images/logos/truffle.svg'

export const Tutorials = [
  {
    copy: 'Access web3 libraries and send transactions via the Goerli testnet',
    icon: INFURA_LOGO,
    id: 'tutorial-transactions',
    link: `${METAMASK_DOCS_DEVELOPER_URL}/infura/tutorials/ethereum/send-a-transaction`,
    title: 'Send a transaction'
  },
  {
    copy: 'Build a web3 frontend and deploy a basic smart contract using React',
    icon: TRUFFLE_LOGO,
    id: 'tutorial-truffle',
    link: `${METAMASK_DOCS_DEVELOPER_URL}/infura/tutorials/ethereum/create-a-dapp-using-truffle-and-react`,
    title: 'Create a dapp using Truffle'
  },
  {
    copy: 'Use the web3 JavaScript library and create and deploy a smart contract',
    icon: INFURA_LOGO,
    id: 'tutorial-deploy-contract',
    link: `${METAMASK_DOCS_DEVELOPER_URL}/infura/tutorials/ethereum/deploy-a-contract-using-web3.js`,
    title: 'Deploy a contract'
  }
]

export const ArticleItemsData = [
  {
    copy: 'Test sending a variety of requests directly from our documentation.',
    cta: 'Send requests',
    icon: faSquareTerminal,
    link: `https://docs.metamask.io/services/`,
    title: 'Send Requests'
  },
  {
    copy: 'Use MetaMask SDK to connect user wallets to your app.',
    cta: 'Integrate metamask',
    icon: faWallet,
    link: 'https://docs.metamask.io/wallet/how-to/connect/',
    title: 'Integrate MetaMask'
  },
  {
    copy: 'A series of interactive lessons to begin your Web3 journey.',
    cta: 'Start learning',
    icon: faGraduationCap,
    link: 'https://metamask.io/developer/',
    title: 'MetaMask Developer Center'
  },
  {
    copy: 'Share your needs on Discord to get personalized support.',
    cta: 'Access our community',
    icon: faDiscord,
    link: TRACKED_GETTING_STARTED_DISCORD_LINK,
    title: 'Need help getting started?'
  }
]
